import { render } from "./HeroiconsOutlineCollection.vue?vue&type=template&id=436522ee"
const script = {}

import exportComponent from "/Users/administrator/Sites/HengFuTong/extends/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCollection.vue"]])

export default __exports__